export class BillSubmissionMethod {
	public id: number;
	public name: string;
	public sortOrder: number;
	public showEmail: boolean;
	public showFolderName: boolean;
	public showUsername: boolean;
	public showPassword: boolean;

	constructor(billSubmissionMethod?: Subset<BillSubmissionMethod>) {
		Object.assign(this, billSubmissionMethod);
	}
}

export class EnterpriseBillSubmissionMethod {
	public id: number;
	public enterpriseId: number;
	public billSubmissionMethodId: number;
	public email: string;
	public folderName: string;
	public username: string;
	public password: string;

	public billSubmissionMethod: BillSubmissionMethod;

	constructor(enterpriseBillSubmissionMethod?: Subset<EnterpriseBillSubmissionMethod>) {
		Object.assign(this, enterpriseBillSubmissionMethod);

		this.billSubmissionMethod = this.billSubmissionMethod ? new BillSubmissionMethod(this.billSubmissionMethod) : this.billSubmissionMethod;
	}
}
